import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSackDollar } from "react-icons/fa6";
import { LaptopMinimalCheck, ShieldEllipsis } from "lucide-react";
import { HiOutlineChatAlt2 } from "react-icons/hi";
import '../../Home/Home.css';

const sections = [
  {
    title: "Multi-Insurer Platform",
    description:
      "Manage your insurance portfolio across all life and Non-life insurance companies",
    icon: <ShieldEllipsis size={50} />
  },
  {
    title: "Dedicated Support",
    description:
      "Enhance your brand image by offering your customers a best in the class white labelled app on Android & iOS",
    icon: <HiOutlineChatAlt2 size={50} />,
  },
  {
    title: "Easy to Use Interface",
    description:
      "Stay in control of your business on the move with an Advisor App",
    icon: <LaptopMinimalCheck size={50} />,
  },
  {
    title: "Pocket Friendly",
    description:
      "Advanced analytics and data mining provide cross sell and up sell opportunities thereby enabling you to get greater share from your customer’s wallet",
    icon: <FaSackDollar size={50} />,
  }
];

const Features = () => (
  <div>
    <div className="flex justify-center">
      <h2 className="m-auto text-center mt-5 inline-block border-b-2 border-brandRed p-2">
        i-sure for Insurance Professionals
      </h2>
    </div>

    {/* Grid responsive section */}
   <section className="flex flex-col md:flex-row md:flex-wrap justify-center items-center gap-4 w-5/6 m-auto mt-4 p-3">
  {sections.map((section, index) => (
    <div
      key={index}
      className="w-full md:w-[48%] lg:w-[22%] flex flex-col feature-container justify-center gap-6 mb-0"
    >
      <div className="flex justify-center items-center w-full feature-image">
        <div className="!h-20 !w-auto featureImage mt-3">
          <div className="mt-3">{section.icon}</div>
        </div>
      </div>
      <div className="curved-label">
        <h2>{section.title}</h2>
        {/* <p className="text-center text-lg">{section.description}</p> */}
      </div>
    </div>
  ))}
</section>

  </div>
);

export default Features;
